module.exports = __webpack_public_path__ + "static/media/avatar.2e24f085.jpg";